import React from "react";
import { IMG_URl } from "../../common/img_url";
import { useTranslation } from "react-i18next";

function MenuElement({ element, name, props }: any) {
  const { t } = useTranslation();

  return (
    <div
      className="relative w-full h-28 rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer group"
      onClick={() => props.onClickMenu(element.id)}
    >
      <div
        className="w-full h-full bg-cover bg-center transform group-hover:scale-110 transition-transform duration-300"
        style={{ backgroundImage: `url(${IMG_URl}${element.image})` }}
      ></div>

      <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition-colors duration-300"></div>

      <div
        className={`absolute bottom-2 ${
          name === "name_en" ? "left-2" : "right-2"
        } text-onBackground text-sm font-bold drop-shadow-md`}
      >
        {element[name]}
      </div>
    </div>
  );
}

export default MenuElement;

// <div
//   className="relative w-full h-28 rounded-lg overflow-hidden"
//   onClick={() => props.onClickMenu(element.id)}
// >
//   <div
//     className="w-full h-full bg-cover bg-center"
//     style={{ backgroundImage: `url(${IMG_URl}${element.image})` }}
//   ></div>

//   <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//   <div
//     className={`absolute bottom-2 ${
//       name === "name_en" ? "left-2" : "right-2"
//     }  text-white text-sm font-bold`}
//   >
//     {element[name]}
//   </div>
// </div>
